import {Component, OnDestroy, OnInit} from '@angular/core';

import {Associacao} from "../../../associacao/associacao-stepper/associacao";
import {CarteiraService} from "../../../carteira/carteira.service";
import {RegraService} from "../../../regra/regra.service";
import {Subscription} from "rxjs";
import {ToastService} from "maps-angular-components";

@Component({
    selector: 'app-modal-associacao',
    templateUrl: './modal-associacao.component.html',
    styleUrls: ['./modal-associacao.component.scss']
})
export class ModalAssociacaoComponent implements OnInit, OnDestroy {

    constructor(private readonly carteiraService: CarteiraService,
                private readonly regraService: RegraService,
                private readonly toastService: ToastService) {
    }

    data: Associacao;

    carteira: string;

    regra: string;
    private readonly subscriptions = new Subscription();


    ngOnInit(): void {

        if (this.data) {
            if(!this.data.carteira){
                this.subscriptions.add(
                    this.carteiraService.findById(this.data.carteiraId).subscribe(cart => {
                        this.carteira = cart.nome;
                    }, e => this.toastService.erro(e.error.message)));

            }else{
                this.carteira = this.data.carteira
            }

            if(!this.data.regra){
                this.subscriptions.add(
                    this.regraService.findById(this.data.regraId).subscribe(regra => {
                        this.regra = regra.nome;
                    }, e => this.toastService.erro(e.erro.message)));
            }else{
                this.regra = this.data.regra;
            }

        }

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
